module.exports = __webpack_public_path__ + "img/p_sponsor_bg.8f703446.png";